export const NAME = 'paperCategories';